import { IPagination, IResponseRequest } from '../index.js'

export interface IBaseResponseData {
  pagination: IPagination
  request: IResponseRequest
}
